import React, { useState } from 'react';
import './ProjectViewerSidebar.css';

// Import sidebar option components
import Views from './Views/Views';
import Animations from './Animations/Animations';
import Collaboration from './Collaboration/Collaboration';
import Layers from './Layers/Layers';
import Environment from './Environment/Environment';
import Measure from './Measure/Measure';
import VirtualTour from './VirtualTour/VirtualTour';
import Address from './Address/Address';

const ProjectViewerSidebar = ({ project, isCollapsed }) => {
  const [activeSection, setActiveSection] = useState('views');
  const [currentPage, setCurrentPage] = useState(null); // null = main menu, 'sectionName' = specific page

  const sidebarOptions = [
    { id: 'views', label: 'Views', icon: 'fas fa-th', component: Views },
    { id: 'animations', label: 'Animations', icon: 'fas fa-play', component: Animations },
    { id: 'collaboration', label: 'Collaboration', icon: 'fas fa-users', component: Collaboration },
    { id: 'layers', label: 'Layers', icon: 'fas fa-layer-group', component: Layers },
    { id: 'environment', label: 'Environment', icon: 'fas fa-sun', component: Environment },
    { id: 'measure', label: 'Measure', icon: 'fas fa-ruler', component: Measure },
    { id: 'virtualtour', label: 'Virtual Tour', icon: 'fas fa-cog', component: VirtualTour },
    { id: 'address', label: 'Address', icon: 'fas fa-map-marker-alt', component: Address },
  ];

  const ActiveComponent = sidebarOptions.find(option => option.id === activeSection)?.component;

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    setCurrentPage(sectionId);
  };

  const handleBackClick = () => {
    setCurrentPage(null);
  };

  if (isCollapsed) {
    return (
      <div className="project-viewer-sidebar collapsed">
        <div className="sidebar-nav-collapsed">
          {sidebarOptions.map(option => (
            <button
              key={option.id}
              className={`nav-item-collapsed ${activeSection === option.id ? 'active' : ''}`}
              onClick={() => handleSectionClick(option.id)}
              title={option.label}
            >
              <i className={option.icon}></i>
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="project-viewer-sidebar">
      {currentPage ? (
        // Show specific page with back button
        <div className="sidebar-page">
          <div className="page-header">
            <h3>{sidebarOptions.find(option => option.id === currentPage)?.label}</h3>
            <button className="sidebar-back-button" onClick={handleBackClick}>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
          <div className="page-content">
            {ActiveComponent && <ActiveComponent project={project} />}
          </div>
        </div>
      ) : (
        // Show main navigation menu
        <div className="sidebar-nav">
          {sidebarOptions.map(option => (
            <button
              key={option.id}
              className={`nav-item ${activeSection === option.id ? 'active' : ''}`}
              onClick={() => handleSectionClick(option.id)}
            >
              <i className={option.icon}></i>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectViewerSidebar;
